angular.module('unica_media_moderation.media_services')

.factory('MediaModerationEditService', function ($http, getBaseApiURL, getBaseWebURL) {

	var mediaEditService = {};

	mediaEditService.approveMedia = function (invId, fieldId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-moderation/approve/' + invId + '/' + fieldId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};

	mediaEditService.declineMedia = function (invId, fieldId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-moderation/decline/' + invId + '/' + fieldId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};

	mediaEditService.restoreMedia = function (invId, fieldId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media-moderation/restore/' + invId + '/' + fieldId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};


	return mediaEditService;
});